/* Back9Lab tussenversie: kleine scripts.
   Tweekleurige koppen (zelfde regel als snippet b9-accent) voor secties die hun kop niet via section-header/rich-text renderen,
   zoals image-with-text en de ss-*-secties (testimonials). Koppen met eigen opmaak (bijv. <strong>) blijven ongemoeid. */
(function () {
  function accent(h) {
    if (h.querySelector('*') || h.dataset.b9acc) return;
    var t = (h.textContent || '').trim();
    if (!t || t.length > 90) return;
    var words = t.split(/\s+/), up = t.toUpperCase(), i = 0;
    if (up === 'BESTSELLERS') { h.innerHTML = '<span class="b9-accent">' + t.slice(0, 4) + '</span>' + t.slice(4); h.dataset.b9acc = 1; return; }
    if (words.length > 1 && (words[0].toUpperCase() === 'ALL' || up.indexOf('YOU MAY ALSO') === 0)) i = words.length - 1;
    words[i] = '<span class="b9-accent">' + words[i].replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</span>';
    h.innerHTML = words.map(function (w, k) { return k === i ? w : w.replace(/&/g, '&amp;').replace(/</g, '&lt;'); }).join(' ');
    h.dataset.b9acc = 1;
  }
  function run() {
    document.querySelectorAll('[id^="shopify-section"] h2, [id^="shopify-section"] h3').forEach(function (h) {
      if (h.closest('header, footer, .header, .product-information, .product-card, .side-panel, .mobile-menu-drawer, .slideshow, [class*="hero"], [class*="accordion"], .collapsible__content, details')) return;
      accent(h);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* PDP-fotobox zoals HeadCaddy (13 okt): snellere, soepelere Flickity, pijlen op desktop, overige foto's vooraf laden. */
(function () {
  var s = document.getElementById('Product-Slider');
  if (!s) return;
  var tries = 0, inst = null;
  function arrows() {
    var box = s.closest('.product-image-container');
    if (!box || box.querySelector('.b9-gal-btn') || s.querySelectorAll('.product-images__slide').length < 2) return;
    var svg = function (d) { return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + d + '" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'; };
    [['prev', 'Previous image', 'M15 5l-7 7 7 7'], ['next', 'Next image', 'M9 5l7 7-7 7']].forEach(function (a) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'b9-gal-btn b9-gal-' + a[0];
      b.setAttribute('aria-label', a[1]);
      b.innerHTML = svg(a[2]);
      b.addEventListener('click', function () {
        var f = window.Flickity && window.Flickity.data ? window.Flickity.data(s) : null;
        if (f) { a[0] === 'prev' ? f.previous(true) : f.next(true); }
      });
      box.appendChild(b);
    });
  }
  function tune() {
    var F = window.Flickity;
    inst = F && F.data ? F.data(s) : null;
    if (!inst) { if (tries++ < 40) setTimeout(tune, 250); return; }
    inst.options.selectedAttraction = 0.2;
    inst.options.friction = 0.8;
    var r = {};
    [].forEach.call(s.querySelectorAll('.product-single__media'), function (m) { r[m.getAttribute('style') || ''] = 1; });
    if (inst.options.adaptiveHeight && Object.keys(r).length === 1) { inst.options.adaptiveHeight = false; if (inst.resize) inst.resize(); }
    arrows();
  }
  function preload() {
    var imgs = s.querySelectorAll('img.lazyload'), i = 0;
    function next() {
      if (i >= imgs.length) return;
      var img = imgs[i++];
      img.decoding = 'async';
      if (window.lazySizes && window.lazySizes.loader) window.lazySizes.loader.unveil(img); else img.classList.add('lazypreload');
      setTimeout(next, 100);
    }
    next();
  }
  function go() { tune(); (window.requestIdleCallback || function (cb) { setTimeout(cb, 200); })(preload); }
  if (document.readyState === 'complete') go(); else window.addEventListener('load', go);
})();

/* Social proof-tekst (Donny, 13 okt): vangnet naast b9-copy-fixes, voor varianten van het app-blok die de server-vervanging missen. */
(function () {
  var NEW = '&amp; <strong>21k+</strong> Golfers Wear Back9Lab On The Course';
  function fix() {
    document.querySelectorAll('.qodes--social_proof-text').forEach(function (el) {
      if (el.textContent.indexOf('Wear Back9Lab') === -1) el.innerHTML = '<p>' + NEW + '</p>';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix); else fix();
  window.addEventListener('load', fix);
})();

/* Productkaarten zoals HeadCaddy (14 okt): swipebare foto's met puntjes en pijlen. Back9Lab (Donny): met kleuren swipe je door de kleuren
   en schuiven de bolletjes mee; 'Choose options' opent de snelkoppeling met de gekozen kleur al geselecteerd. Bron: hc-swipe.js + hc-qv.js. */
(function () {
  if (!document.getElementById('b9-cs-css')) { var st = document.createElement('style'); st.id = 'b9-cs-css'; st.textContent = '.b9-cs{position:absolute;inset:0;z-index:11;overflow:hidden;background:var(--b9-card-bg,#F3F3F0)}.b9-cs-track{position:absolute;inset:0;display:flex;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;scrollbar-width:none;overscroll-behavior-x:contain}.b9-cs-track::-webkit-scrollbar{display:none}.b9-cs-slide{position:relative;flex:0 0 100%;width:100%;height:100%;scroll-snap-align:start;scroll-snap-stop:always;background:var(--b9-card-bg,#F3F3F0);isolation:isolate}.b9-cs-slide a{display:block;width:100%;height:100%}.b9-cs-slide img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;z-index:1!important;opacity:1!important;max-width:none!important;mix-blend-mode:multiply!important}.b9-cs-dots{position:absolute;left:0;right:0;bottom:6px;z-index:15;display:flex;gap:4px;padding:0 8px}.b9-cs-dots span{flex:1 1 0;height:3px;border-radius:30px;background:rgba(26,42,38,.22);cursor:pointer}.b9-cs-dots span.on{background:#1A2A26}.b9-cs-prev,.b9-cs-next{position:absolute;top:50%;transform:translateY(-50%);z-index:20;display:none;align-items:center;justify-content:center;width:32px;height:32px;padding:0;border:0;border-radius:50%;background:rgba(255,255,255,.92);box-shadow:0 2px 10px rgba(0,0,0,.18);color:#1A2A26;cursor:pointer}.b9-cs-prev svg,.b9-cs-next svg{display:block;width:16px;height:16px}.b9-cs-prev{left:10px}.b9-cs-next{right:10px}@media only screen and (min-width:768px){.b9-cs-prev,.b9-cs-next{width:40px;height:40px;display:flex}.b9-cs-prev svg,.b9-cs-next svg{width:20px;height:20px}.b9-cs-prev{left:14px}.b9-cs-next{right:14px}}@media (hover:hover) and (pointer:fine){.b9-cs-prev,.b9-cs-next,.b9-cs-dots{opacity:0;visibility:hidden;transition:opacity .25s ease,visibility .25s ease}product-card:hover .b9-cs-prev,product-card:hover .b9-cs-next,product-card:hover .b9-cs-dots,.b9-cs-prev:focus-visible,.b9-cs-next:focus-visible{opacity:1;visibility:visible}}.b9-cs-single .b9-cs-prev,.b9-cs-single .b9-cs-next,.b9-cs-single .b9-cs-dots{display:none!important}.b9-cs-on .product-card--featured-image-link>img,.b9-cs-on .product-card--featured-image-link>.product-primary-image,.b9-cs-on .product-card--featured-image-link>.product-secondary-image{visibility:hidden!important}.b9-cs-on .product-secondary-images-nav{display:none!important}.b9-cs-on .product-card--badges{z-index:13}.b9-cs-on .product-card-quickview,.b9-cs-on .product-card-size-options{z-index:13}.products.carousel .carousel__slide>product-card.product-card{flex:1 1 auto;align-self:stretch;height:auto!important;min-height:0}product-card.product-card .product-card-info{flex:1 1 auto}product-card.product-card .product-card--add-to-cart-button-container{margin-top:auto}'; document.head.appendChild(st); }
  var touch = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  var AL = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false"><path d="M12.5 4.375 6.875 10l5.625 5.625" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
  var AR = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false"><path d="m7.5 4.375 5.625 5.625L7.5 15.625" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
  function srcOf(img) { return img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src') || ''; }
  function sized(u, w) { return u && (/[?&]width=\d+/.test(u) ? u.replace(/([?&]width=)\d+/, '$1' + w) : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w); }
  function list(a) { return (a || '').split('|').filter(Boolean); }
  function count(cs) { return cs.b9Track.children.length; }
  function current(cs) { return Math.round(cs.b9Track.scrollLeft / Math.max(cs.b9Track.clientWidth, 1)); }
  function go(cs, i) { var n = count(cs); if (!n) return; i = (i % n + n) % n; cs.b9Track.scrollTo({ left: i * cs.b9Track.clientWidth, behavior: 'smooth' }); }
  var MAX = 4; /* zelfde als b9_max in snippet product-card-swatch */
  function fill(cs, urls, alt, hrefs) {
    var href = cs.b9Link.getAttribute('href'), track = cs.b9Track, dots = cs.b9Dots;
    track.innerHTML = ''; dots.innerHTML = '';
    cs.classList.toggle('b9-cs-single', urls.length < 2);
    urls.forEach(function (u, i) {
      var s = document.createElement('div'); s.className = 'b9-cs-slide';
      var img = document.createElement('img');
      img.alt = alt || ''; img.decoding = 'async'; img.draggable = false; if (i) img.loading = 'lazy';
      img.src = sized(u, 375); img.srcset = sized(u, 375) + ' 375w, ' + sized(u, 770) + ' 770w'; img.sizes = '(min-width: 768px) 25vw, 50vw';
      var a = document.createElement('a'); a.href = (hrefs && hrefs[i]) || href; a.tabIndex = i ? -1 : 0; a.setAttribute('aria-label', alt || ''); a.draggable = false;
      a.appendChild(img); s.appendChild(a); track.appendChild(s);
      var d = document.createElement('span'); if (!i) d.className = 'on';
      d.addEventListener('click', function (e) { e.preventDefault(); go(cs, i); });
      dots.appendChild(d);
    });
    track.scrollLeft = 0;
  }
  function allSw(card) { return [].slice.call(card.querySelectorAll('.product-card-swatch')); }
  function swUrl(sw) { return list(sw.getAttribute('data-series'))[0] || ''; }
  function activeSwatch(card) { return card.querySelector('.product-card-swatch.active') || card.querySelector('.product-card-swatch'); }
  function setLinks(card, href) {
    if (!href) return;
    [].forEach.call(card.querySelectorAll('a.product-card--featured-image-link, a.product-card-title'), function (a) { a.setAttribute('href', href); });
  }
  function setActive(sw) {
    var all = sw.parentNode ? sw.parentNode.querySelectorAll('.product-card-swatch') : [];
    [].forEach.call(all, function (el) { el.classList.remove('active', 'b9-cur'); });
    sw.classList.add('active', 'b9-cur');
  }
  /* Max. 4 bolletjes zichtbaar; staat de foto op een kleur verderop, dan schuift die kleur op plek 4 */
  function showSwatch(card, sw) {
    var all = allSw(card), idx = all.indexOf(sw);
    all.forEach(function (s, k) {
      var hide = k >= MAX;
      if (idx >= MAX) hide = k >= MAX - 1 && k !== idx;
      s.classList.toggle('b9-sw-more', hide);
    });
  }
  function sync(card, i) {
    var cs = card.b9Cs; if (!cs || !cs.b9Sws) return;
    var sw = cs.b9Sws[i]; if (!sw) return;
    setActive(sw); showSwatch(card, sw); setLinks(card, sw.getAttribute('data-href'));
  }
  function init(fig) {
    if (fig.dataset.b9Cs) return;
    var card = fig.closest('product-card'), link = fig.querySelector('.product-card--featured-image-link');
    if (!card || !link) return;
    var prim = link.querySelector('.product-primary-image');
    /* Back9Lab (Donny, 14 okt): met kleuren swipe je door de kleuren (één foto per kleur); lifestyle pas op de productpagina */
    var sws = allSw(card).filter(swUrl), urls, hrefs = null, start = 0;
    if (sws.length > 1) {
      urls = sws.map(swUrl);
      hrefs = sws.map(function (s) { return s.getAttribute('data-href'); });
      start = Math.max(0, sws.indexOf(activeSwatch(card)));
    } else {
      sws = null;
      urls = list(fig.getAttribute('data-b9-images'));
      if (!urls.length) urls = [].slice.call(link.querySelectorAll('.product-primary-image, .product-secondary-image')).map(srcOf).filter(Boolean);
    }
    if (!urls.length) return;
    fig.dataset.b9Cs = '1';
    var cs = document.createElement('div');
    cs.className = 'b9-cs';
    cs.innerHTML = '<div class="b9-cs-track"></div><div class="b9-cs-dots"></div><button type="button" class="b9-cs-prev" aria-label="Previous image">' + AL + '</button><button type="button" class="b9-cs-next" aria-label="Next image">' + AR + '</button>';
    cs.b9Track = cs.querySelector('.b9-cs-track'); cs.b9Dots = cs.querySelector('.b9-cs-dots'); cs.b9Link = link; cs.b9Sws = sws;
    link.insertAdjacentElement('afterend', cs);
    fig.classList.add('b9-cs-on'); card.b9Cs = cs;
    fill(cs, urls, (prim && prim.alt) || link.getAttribute('title') || '', hrefs);
    function dots(i) { [].forEach.call(cs.b9Dots.children, function (d, k) { d.className = k === i ? 'on' : ''; }); }
    if (sws) {
      sync(card, start);
      if (start) {
        var jump = function () { if (cs.b9Track.clientWidth) { cs.b9Track.scrollLeft = start * cs.b9Track.clientWidth; dots(start); } };
        requestAnimationFrame(jump); window.addEventListener('load', jump);
      }
    }
    cs.querySelector('.b9-cs-prev').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(cs, current(cs) - 1); });
    cs.querySelector('.b9-cs-next').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(cs, current(cs) + 1); });
    cs.b9Dots.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); });
    var t;
    cs.b9Track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () { var i = current(cs); dots(i); if (cs.b9Sws) sync(card, i); }, 60);
    }, { passive: true });
  }
  /* Bolletje aanwijzen of aantikken: foto schuift naar die kleur */
  function pick(sw) {
    var card = sw.closest('product-card'); if (!card) return;
    var cs = card.b9Cs;
    if (cs && cs.b9Sws) {
      var i = cs.b9Sws.indexOf(sw);
      if (i > -1) { go(cs, i); sync(card, i); return; }
    }
    setActive(sw); setLinks(card, sw.getAttribute('data-href'));
  }
  if (!touch) {
    document.addEventListener('mouseover', function (e) {
      var sw = e.target.closest && e.target.closest('product-card .product-card-swatch');
      if (sw && !sw.classList.contains('b9-cur')) pick(sw);
    }, true);
  }
  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('product-card .product-card-swatch');
    if (sw) { e.preventDefault(); e.stopImmediatePropagation(); pick(sw); }
  }, true);

  /* Swipen in een carrousel (Flickity) zonder dat de carrousel meeschuift */
  var T = null;
  function slider(tr) { var s = tr.closest('.flickity-enabled'); return s && window.Flickity ? window.Flickity.data(s) : null; }
  window.addEventListener('touchstart', function (e) {
    var tr = e.target && e.target.closest && e.target.closest('.b9-cs-track'); if (!tr) return;
    var fl = slider(tr); if (!fl) return;
    if (fl.isDraggable) fl.isDraggable = false; else fl = null;
    var p = e.touches ? e.touches[0] : e;
    T = { tr: tr, fl: fl, x: p.clientX, y: p.clientY, sl: tr.scrollLeft, dir: null, dx: 0 };
    e.stopPropagation();
  }, { capture: true, passive: true });
  window.addEventListener('touchmove', function (e) {
    if (!T || !e.touches) return;
    var p = e.touches[0], dx = p.clientX - T.x, dy = p.clientY - T.y;
    if (!T.dir && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) { T.dir = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y'; if (T.dir === 'x') T.tr.style.scrollSnapType = 'none'; }
    if (T.dir === 'x') { e.preventDefault(); T.dx = dx; T.tr.scrollLeft = T.sl - dx; }
    e.stopPropagation();
  }, { capture: true, passive: false });
  function end() {
    if (!T) return;
    var t0 = T; T = null;
    if (t0.dir === 'x') {
      var w = Math.max(t0.tr.clientWidth, 1), n = t0.tr.children.length, i = Math.round(t0.sl / w);
      if (t0.dx < -40) i++; else if (t0.dx > 40) i--;
      i = Math.max(0, Math.min(n - 1, i));
      t0.tr.scrollTo({ left: i * w, behavior: 'smooth' });
      setTimeout(function () { t0.tr.style.scrollSnapType = ''; }, 450);
      t0.tr.b9NoClick = Date.now();
    }
    if (t0.fl) setTimeout(function () { t0.fl.isDraggable = true; }, 0);
  }
  window.addEventListener('touchend', end, { capture: true, passive: true });
  window.addEventListener('touchcancel', end, { capture: true, passive: true });
  window.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'mouse') return;
    var tr = e.target && e.target.closest && e.target.closest('.b9-cs-track');
    if (tr && slider(tr)) e.stopPropagation();
  }, { capture: true, passive: true });
  window.addEventListener('click', function (e) {
    var tr = e.target && e.target.closest && e.target.closest('.b9-cs-track');
    if (tr && tr.b9NoClick && Date.now() - tr.b9NoClick < 500) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  function scan(root) { [].forEach.call((root || document).querySelectorAll('product-card .product-card--featured-image'), init); }
  scan();
  new MutationObserver(function (ms) {
    ms.forEach(function (m) {
      [].forEach.call(m.addedNodes, function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches && n.matches('product-card .product-card--featured-image')) init(n); else if (n.querySelectorAll) scan(n);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  /* 'Choose options': kies in de snelkoppeling dezelfde variant als de kleur op de kaart (radio's en dropdowns) */
  document.addEventListener('click', function (e) {
    var q = e.target.closest && e.target.closest('product-card quick-view');
    if (!q) return;
    var card = q.closest('product-card'), a = card && card.querySelector('a.product-card-title');
    var m = a && (a.getAttribute('href') || '').match(/[?&]variant=(\d+)/);
    if (!m) return;
    var vid = m[1], old = document.querySelector('#Product-Drawer-Content variant-selects'), tries = 0;
    (function wait() {
      var vs = document.querySelector('#Product-Drawer-Content variant-selects');
      if (!vs || vs === old) { if (++tries < 60) setTimeout(wait, 100); return; }
      var js = vs.querySelector('script[type="application/json"]'), data;
      try { data = JSON.parse(js.textContent); } catch (err) { return; }
      var v = data.filter(function (x) { return String(x.id) === vid; })[0];
      if (!v) return;
      var sets = [].slice.call(vs.querySelectorAll('fieldset'));
      v.options.forEach(function (o, i) {
        var fs = sets[i]; if (!fs) return;
        var sel = fs.querySelector('select');
        if (sel) { if (sel.value !== o) { sel.value = o; sel.dispatchEvent(new Event('change', { bubbles: true })); } return; }
        var r = [].filter.call(fs.querySelectorAll('input[type=radio]'), function (x) { return x.value === o; })[0];
        if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    })();
  }, true);
})();
